import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { useRouteMatch } from 'react-router'
import transactionService from '../../../axios/services/transactionService'
import useAsync from '../../../components/hooks/useAsync'
import Timeline from '../../../components/Timeline'
import Agreement from './Agreement'
import PaymentMethod from './PaymentMethod'
import Verification from './Verification'
import DetailSuccess from './DetailTrx'

const TransactionDetailSucess = () => {
  const [step, setStep] = useState(1);
  const [data, setData] = useState({})

  const [completedOne, setCompletedOne] = useState(false)
  const [completedTwo, setCompletedTwo] = useState(false)
  const [completedThree, setCompletedThree] = useState(false)

  const { params: { id, code } } = useRouteMatch();

  const {
    pending,
    value: { data: { transactions = [] } = {} } = {},
  } = useAsync(transactionService.transactionList, { id })

  return (
    <>
      <Helmet title={`Detail Transaksi (${code})`} />
      <h1 className="mb-32">Daftar Transaksi</h1>

      <DetailSuccess
        setCompletedOne={setCompletedOne}
        setStep={setStep}
        items={transactions}
        loading={pending}
      />
    </>
  )
}

export default TransactionDetailSucess
